var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUiArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 144544",
  fill: "none",
  d: "M0 0h24v24H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.101 10.563h18.668a1.191 1.191 0 01.877.354 1.191 1.191 0 01.354.877 1.192 1.192 0 01-.354.877 1.192 1.192 0 01-.877.353H4.101l8.484 8.484a1.157 1.157 0 01.361.857 1.219 1.219 0 01-.387.873 1.286 1.286 0 01-.865.369 1.148 1.148 0 01-.865-.369L.423 12.832a1.361 1.361 0 01-.325-.486 1.577 1.577 0 01-.095-.552 1.577 1.577 0 01.095-.552 1.361 1.361 0 01.325-.486L10.829.35a1.175 1.175 0 01.844-.349 1.227 1.227 0 01.885.349 1.206 1.206 0 01.382.877 1.206 1.206 0 01-.382.877z",
  fill: "#333"
})));
export default __webpack_public_path__ + "static/UI-arrow-left.599ed1b77fb13583677e12204917b8a8.svg";
export { SvgUiArrowLeft as ReactComponent };